export default __webpack_public_path__ + "static/media/karel-image-cropped.7658398a.svg";